/*
 * Created on Thu Oct 12 2023 10:24:49 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import CallToActionSection from "./components/CallToActionSection";
import FeaturesSection from "./components/FeaturesSection";
import HeroSection from "./components/HeroSection";
import MarketingSection from "./components/MarketingSection";
import FlexOfficeTimeline from "./components/TimeLine";
import WorkingHoursSection from "./components/WorkingHoursSection";

const FlexOfficeMain = () => (
  <>
    <HeroSection />
    <MarketingSection />
    <FlexOfficeTimeline />
    <WorkingHoursSection />
    <FeaturesSection />
    <CallToActionSection />
  </>
);

export default FlexOfficeMain;
